const languages = [
  { name: 'EN', id: 1, value: 'en-US' },
  { name: 'ES', id: 2, value: 'es-US ' },
];

export default languages;
